import get from 'lodash/get';
import { createElement } from 'react';
import { connect } from 'react-redux';
import { useUserStatsAndRankings } from 'src/_shared/hooks/useUserStatsAndRankings.js';
import { withQueryAnnouncementByCompanyId } from 'src/_shared/api/components/announcements/';
import { withQueryBonusByUserId } from 'src/_shared/api/components/bonuses/';
import {
	withListMyReferralsContacts,
	withMyContacts,
} from 'src/_shared/api/components/contacts/';
import { withJobMatchByCompanyId } from 'src/_shared/api/components/dashboard/';
import { withListDepartment } from 'src/_shared/api/components/departments/';
import { withCreateWebNotification } from 'src/_shared/api/components/network/';
import { withCreateReferral } from 'src/_shared/api/components/referrals/';
import {
	withGetCompany,
	withGetCompanyData,
} from 'src/_shared/api/components/settings/';
import { withModifyTieredBonus } from 'src/_shared/api/components/tiered-bonuses';
import { withMyJobMatches } from 'src/_shared/index.js';
import { withCreateUserJobShare } from 'src/_shared/api/components/users/';
import { withUpdateJob } from 'src/_shared/api/components/jobs/';
import { dashboardActions, userActions } from 'src/actions.js';
import { compose } from '../_shared/services/utils.js';
import DashboardComponent from './DashboardComponent.jsx';

const mapStateToProperties = (state) => {
	const { currentUser } = state.user;

	const extendedContactsData = get(currentUser, 'extendedContactData', []);
	let referrals = [];
	for (const contact of extendedContactsData) {
		referrals = [...referrals, ...get(contact, 'referrals', [])];
	}

	const { allMultiLingualData } = state.dashboard;
	return {
		currentUser,
		extendedReferrals: referrals,
		first: 1000,
		after: '',
		companyId: currentUser?.companyId,
		filter: { companyId: { eq: currentUser?.companyId } },
		limit: 1000,
		languageCode:
			currentUser?.languageCode === null ? 'US' : currentUser?.languageCode,
		allMultiLingualData,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		inviteEmployeesSubmit(
			users,
			fileData,
			role,
			createdById,
			companyId,
			languageCode,
			callback
		) {
			dispatch(
				dashboardActions.createInviteEmployeesAction(
					users,
					fileData,
					role,
					createdById,
					companyId,
					languageCode,
					callback
				)
			);
		},
		setMultiLingualData(data) {
			dispatch(dashboardActions.createSetMultiLingualData(data));
		},
		setCurrentUser(user) {
			dispatch(userActions.createSetCurrentUserAction(user));
		},
		updateCurrentUser(values) {
			dispatch(userActions.updateCurrentUser(values));
		},
	};
};

// DashboardComponent is still a class, so the hook is called here and its
// results passed down as props. Fold this into the component once it's a
// function component.
const DashboardWithUserStats = (props) =>
	createElement(DashboardComponent, {
		...props,
		...useUserStatsAndRankings(props.currentUser?.id),
	});

const DashboardContainer = compose(
	withListDepartment,
	withJobMatchByCompanyId,
	withMyJobMatches,
	withGetCompanyData,
	withModifyTieredBonus,
	withQueryBonusByUserId,
	withGetCompany,
	withCreateReferral,
	withQueryAnnouncementByCompanyId,
	withMyContacts,
	withListMyReferralsContacts,
	withCreateReferral,
	withCreateWebNotification,
	withCreateUserJobShare,
	withUpdateJob,
)(DashboardWithUserStats);

export const Dashboard = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(DashboardContainer);
